/**
 * See the NOTICE file distributed with this work for additional information
 * regarding copyright ownership.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import React, { memo } from 'react';
import useHasMounted from 'src/shared/hooks/useHasMounted';

import ActivityViewerIdContextProvider from 'src/content/app/regulatory-activity-viewer/contexts/ActivityViewerIdContextProvider';

const LazilyLoadedActivityViewer = React.lazy(
  () => import('./RegulatoryActivityViewer')
);

const ActivityViewerPage = memo(() => {
  const hasMounted = useHasMounted();

  return hasMounted ? <LazilyLoadedActivityViewer /> : null;
});

const WrappedActivityViewerPage = () => (
  <ActivityViewerIdContextProvider>
    <ActivityViewerPage />
  </ActivityViewerIdContextProvider>
);

export default WrappedActivityViewerPage;
